import { render, staticRenderFns } from "./WholesaleInvoice.vue?vue&type=template&id=05090716&scoped=true"
import script from "./WholesaleInvoice.vue?vue&type=script&lang=js"
export * from "./WholesaleInvoice.vue?vue&type=script&lang=js"
import style0 from "./WholesaleInvoice.vue?vue&type=style&index=0&id=05090716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05090716",
  null
  
)

export default component.exports